import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ShopSettingsService } from 'src/app/connect-api/api/shop-settings/shop-settings.service';
import { LoaderService } from 'src/app/services/loader.service';

export type FormAfterCheckoutSettings = {
  mainText: string;
  secondaryText: string;
  link: string;
};

@Component({
  selector: 'app-form-after-checkout',
  templateUrl: './form-after-checkout.component.html',
  styleUrl: './form-after-checkout.component.scss'
})
export class FormAfterCheckoutComponent implements OnInit {
  private setingsService = inject(ShopSettingsService);
  private messageService = inject(MessageService);

  settings: FormAfterCheckoutSettings | null = null;

  form = new FormGroup({
    mainText: new FormControl('', Validators.required),
    secondaryText: new FormControl('', Validators.required),
    link: new FormControl('', Validators.required),
    active: new FormControl(false)
  });

  async ngOnInit(): Promise<void> {
    try {
      LoaderService.showLoader();
      const settings = await this.setingsService.getById('FORM_AFTER_CHECKOUT');

      if (isFormAfterCheckoutSettings(settings)) {
        this.settings = settings;
        this.form.patchValue(settings);
      }
    } catch (error) {
      console.error('Error fetching form after checkout settings:', error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async submit() {
    try {
      LoaderService.showLoader();
      await this.setingsService.update({
        id: 'FORM_AFTER_CHECKOUT',
        ...this.form.value
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Formulário configurado com sucesso'
      });
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao atualizar o formulário pós checkout'
      });
      console.error('Error updating form after checkout settings:', error);
    } finally {
      LoaderService.showLoader(false);
    }
  }
}

function isFormAfterCheckoutSettings(
  value: unknown
): value is FormAfterCheckoutSettings {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const settings = value as Record<string, unknown>;

  return (
    typeof settings['mainText'] === 'string' &&
    typeof settings['secondaryText'] === 'string' &&
    typeof settings['link'] === 'string'
  );
}
